/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOnboardingStatusSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOnboardingStatusRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOnboardingStatusSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOnboardingStatusSecurity$outboundSchema: z.ZodMiniType<
  GetOnboardingStatusSecurity$Outbound,
  GetOnboardingStatusSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getOnboardingStatusSecurityToJSON(
  getOnboardingStatusSecurity: GetOnboardingStatusSecurity,
): string {
  return JSON.stringify(
    GetOnboardingStatusSecurity$outboundSchema.parse(
      getOnboardingStatusSecurity,
    ),
  );
}

/** @internal */
export type GetOnboardingStatusRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOnboardingStatusRequest$outboundSchema: z.ZodMiniType<
  GetOnboardingStatusRequest$Outbound,
  GetOnboardingStatusRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getOnboardingStatusRequestToJSON(
  getOnboardingStatusRequest: GetOnboardingStatusRequest,
): string {
  return JSON.stringify(
    GetOnboardingStatusRequest$outboundSchema.parse(getOnboardingStatusRequest),
  );
}
